export default __webpack_public_path__ + "static/media/play-incomplete.140c82b6.svg";